module.exports = {
	"account.user.driving.licence.already.exist": "Det finns ett annat konto med det här körkortsnumret.",
	"account.user.login.already.exist": "E-postadressen används redan av ett annat konto.",
	"account.user.suspended": "Det gick inte att utföra den här åtgärden eftersom användaren är avstängd",
	"action.add.payment": "Lägg till betalningsmetod",
	"action.complete.my.account": "Fyll i mitt konto",
	"action.confirm.welcome.msg": "Nu går vi",
	"action.create.my.account": "Skapa mitt konto",
	"action.search.update.bookings": "Verifiera tillgänglighet",
	"action.update.payment": "Uppdatera betalningsmetod",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Genom att klicka på \"Bekräfta\" godkänner du användarvillkoren och intygar att du har ett giltigt körkort om du använder delningstjänsten. Mer i {link}.",
	"booking.accept_usage_terms.title": "Användarvillkor",
	"booking.action.cancel.forbidden": "Du kan inte längre avbryta bokningen",
	"booking.action.edit.forbidden": "Du kan inte längre redigera en bokning",
	"booking.add.calendar": "Lägg till i kalendern",
	"booking.confirm": "Confirm booking",
	"booking.confirm_and_pay": "Bekräfta och betala",
	"booking.deposit": "Deposition",
	"booking.deposit.b": "En {damageSafetyDeposit} {currency} debiteras när du bekräftar din bokning.\n Denna deposition kan användas för att täcka eventuella skador som orsakats av fordonet under din resa. \n\n Om fordonet returneras utan skada eller övertid {bookingPrice} {currency} .",
	"booking.deposit.d": "En {bufferPrice} {currency} kommer att göras när du bekräftar din bokning.\n Detta inkluderar priset på din bokning och en avgift för att täcka eventuella överskridanden. \n\n Utan överskridande eller skada på fordon {bookingPrice} {currency} från ditt konto.",
	"booking.deposit.db": "Två bankinsättningar kommer att debiteras när du bekräftar din bokning:\n - Först en i mängden {bufferPrice} {currency} , inklusive priset på din bokning och en avgift för att täcka eventuella överskridanden.\n - Den andra i mängden {damageSafetyDeposit} {currency} att täcka eventuella skador som orsakats av fordonet under din bokning. \n\n Utan överskridande eller fordonsskada {bookingPrice} {currency} .",
	"booking.deposit.info": "En deposition kommer att placeras för din bokning",
	"booking.payment.prebilling.refused.error": "Transaktionen nekades eftersom det inte gick att debitera ditt kreditkort. Försök igen med ett annat kort. Kontakta din bank om problemet kvarstår.",
	"booking.payment.prebilling.technical.error": "Ett fel uppstod under betalningen. Försök igen senare.",
	"booking.success.sub.title": "Tack för att du använder vår tjänst!",
	"booking.success.title": "Grattis, din bokning har skapats!",
	"booking.type.label": "Bokningstyp",
	"booking.type.one_way": "Enkel resa",
	"booking.type.return_trip": "Returresa",
	"booking.update.period.expired": "Perioden för att uppdatera bokningsdatumen har löpt ut",
	"booking.usage.business": "Företag",
	"booking.usage.private": "Privat",
	"booking.view_payment_terms.title": "Betalningsvillkor",
	"booking.voucher.different.code": "Du kan inte ändra din kampanjkod",
	"booking.voucher.placeholder": "I have a voucher code",
	"car.AUTOMATIC": "Automatisk",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elektrisk",
	"car.FOLDING_SEATS": "Fällbara säten",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Manuell",
	"car.PETROL": "Bensin",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Bokningsinformation",
	"car.color": "Färg",
	"car.compact_cars": "Kompaktbil",
	"car.description": "Description",
	"car.details": "Fordonsuppgifter",
	"car.doors": "Dörrar",
	"car.filter.COMMERCIAL": "Kommersiell",
	"car.filter.PASSENGER": "Turism",
	"car.filter.accessories.air_conditioning": "Luftkonditionering",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Stor lastbil",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Antal personer",
	"car.filter.other": "Annat",
	"car.filter.other-nb": "Andra - {nb}",
	"car.filter.vehicle_type": "Fordonstyp",
	"car.filter_energy": "Energi",
	"car.filter_gearbox_type": "Typ av växellåda",
	"car.filter_persons": "personer",
	"car.for_every_additional_km": "Per extra kilometer",
	"car.km_included": "km som ingår",
	"car.motorization": "Motorisering",
	"car.options": "Alternativ",
	"car.parking_additional_info": "Särskilda parkeringsuppgifter",
	"car.places": "Säten",
	"car.pricing": "Priser",
	"car.pricing.estimate": "Prisuppskattning",
	"car.pricing.extra_km_cost_per_day": "Pris för extra km",
	"car.pricing.free_km_per_day": "Km inkl. / 24 h",
	"car.specifications": "Specifikationer",
	"car.transmission": "Växellåda",
	"car.utility_cars": "Nyttofordon",
	"car.version": "Version",
	"company.id.missing.booking.search": "Företags-id är obligatoriskt för den anonyma bokningssökningen",
	"contact_page.phone_call_price": "(GRATIS SAMTAL VIA FAST TELEFON)",
	"contact_page.title_1": "Om du har några frågor gällande din bokning,",
	"contact_page.title_2": "tveka inte att kontakta oss via e-post.",
	"creditcard.data.insufficient.3ds": "På grund av nya 3DS2-krav ber vi dig uppdatera din betalningsinformation.",
	"custom.field.type.boolean": "Ja/Nej",
	"data.with.colon": "{data}:",
	"document.issue.date": "Utfärdandedatum",
	"dropzone.inner.info": "Tillåtna filformat: JPEG, PNG, PDF",
	"dropzone.inner.title": "Ladda upp ditt dokument",
	"error.booking.member_invalid": "Din profil har ännu inte validerats.",
	"error.booking.no.usage": "Ingen användning för dessa bokningsdatum",
	"error.booking.no_credit_card": "Lägg till dina kreditkortsuppgifter först.",
	"error.booking.same_period": "Du har redan en planerad reservation för denna period.",
	"error.change_password.400.bad_request": "Ogiltigt lösenord",
	"error.contract.inactive": "Tjänsten är inte aktiverad för ditt företag, ta kontakt med din servicechef.",
	"error.contract.not-found": "Tjänsten har avbrutits av ditt företag, ta kontakt med din servicechef.",
	"error.credit.card.refused": "Kreditkort nekades",
	"error.forgot_password.404": "Kontrollera din e-post, det finns inget matchande konto",
	"error.form.email.already_exists": "Ange en annan e-postadress",
	"error.form.email_invalid": "Ange en giltig e-post",
	"error.form.inviteCode.notEmpty": "Ange en inbjudningskod",
	"error.form.password.at_least": "Lösenordet måste innehålla minst 8 tecken",
	"error.form.password.at_most": "Lösenordet får innehålla max. 25 tecken",
	"error.form.password.cannot_reset_same": "Ditt nya lösenord måste skilja sig från det nuvarande",
	"error.form.password.digit": "Lösenordet måste innehålla 1 siffra",
	"error.form.password.lower_letter": "Lösenordet måste innehålla 1 liten bokstav",
	"error.form.password.upper_letter": "Lösenordet måste innehålla 1 stor bokstav",
	"error.form.password_confirmation.the_same": "Ange samma lösenord två gånger",
	"error.form.password_old.the_same": "Det nya lösenordet måste skilja sig från tidigare lösenord",
	"error.form.required": "Fyll i alla obligatoriska fält",
	"error.form.suggestion.address.required": "Välj adress från listan med förslag",
	"error.form.technical": "Tekniskt fel",
	"error.get.site.config": "Det gick inte att läsa in webbplatskonfigurationen",
	"error.invite.code.invalid": "Det samhälle som du vill gå med i finns inte",
	"error.login.401.unauthorized": "Ogiltig e-post eller lösenord",
	"error.login.403.user.anonymized": "Ditt konto anonymiseras, du kan inte längre använda det",
	"error.login.422.user.not.enabled": "Ditt konto är inte aktiverat, kolla din e-post och följ instruktionerna för att aktivera kontot.",
	"error.number.above.max": "Värdet kan inte överstiga {value}",
	"error.number.below.min": "Värdet kan inte understiga {value}",
	"error.phone.format.invalid": "Telefonnumrets format är ogiltigt",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Felaktig begäran",
	"error.reset_password.401": "Länken har gått ut, begär ett annat lösenord på webbsidan",
	"error.search.vehicles.403": "Du kan inte komma åt vald webbplats med nuvarande aktiv profil",
	"error.session.expired": "Sessionen har upphört",
	"error.text.length.long": "Detta fält är begränsat till {count} tecken",
	"error.text.length.short": "Detta fält kräver minst {count} tecken",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Namn och födelsedag kan inte ändras efter att din profil har validerats",
	"faq.contactEmailFallback": "via e-post",
	"faq.contactPhoneFallback": "längst ner på sidan",
	"faq.other_question": "Hittar du inte något svar på din fråga?",
	"file_upload_size_exceeded": "Filen är för stor. Maximal storlek: 5 MB",
	"footer.label.legal.information": "Juridisk information",
	"footer.label.personal.data": "Personlig information",
	"footer_callUs": "Ring oss",
	"footer_other": "Övrigt",
	"footer_share": "Följ oss",
	"footer_society_about": "Om oss",
	"footer_society_policy_privacy": "Integritetspolicy",
	"footer_society_term": "Användarvillkor",
	"footer_writeUs": "Skicka ett mejl",
	"forgot_password.confirmation": "En länk för att återställa ditt lösenord har skickats till din e-postadress.",
	"forgot_password.description_line1": "Ange den e-post som är kopplad till ditt konto.",
	"forgot_password.description_line2": "Vi skickar en länk för att återställa ditt lösenord.",
	"forgot_password.submit": "Skicka mig återställa länk",
	"generic.address": "Adress",
	"generic.at": "på",
	"generic.book": "Boka",
	"generic.cancel": "Avbryt",
	"generic.canceled": "Avbruten",
	"generic.city": "Stad",
	"generic.clear": "Rensa",
	"generic.company": "Företag",
	"generic.completed": "Avslutad",
	"generic.country": "Land",
	"generic.email": "E-post",
	"generic.end": "Slut",
	"generic.expires.at": "Giltigt till",
	"generic.extend": "Förläng",
	"generic.file": "Fil",
	"generic.first.name": "Förnamn",
	"generic.last.name": "Efternamn",
	"generic.location.fixture.label": "Platser",
	"generic.location.history.label": "Historia",
	"generic.location.search.placeholder": "Sök en adress, en stad ...",
	"generic.mobile.phone": "Mobiltelefon",
	"generic.modify": "Ändra",
	"generic.mr": "Herr",
	"generic.mrs": "Fru",
	"generic.next": "Nästa",
	"generic.number": "Nummer",
	"generic.passport": "Pass",
	"generic.past.placeholder": "Här hittar du dina tidigare bokningar",
	"generic.phone.number": "Telefonnummer",
	"generic.postal.code": "Postnummer",
	"generic.retry": "Försök igen",
	"generic.save": "Spara",
	"generic.send": "Skicka",
	"generic.start": "Start",
	"generic.text": "Text",
	"generic.today": "I dag",
	"generic.upcoming": "Kommande",
	"generic.updated": "Uppdaterad",
	"generic.user": "Användare",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "För att registrera dig går du bara till företagets sida på intranätet. Där hittar du en länk som tar dig till registreringsprocessen. (Eller skicka en förfrågan om att inkluderas till {contactEmail}). Du får då ett e-postmeddelande med en länk.",
	"helpPage_carSharing_issue1_title": "Hur registrerar man sig?",
	"helpPage_carSharing_issue2_answer": "Du kan återställa ditt lösenord från webbplatsen eller från mobilappen. Då skickas en länk för att skapa ett nytt lösenord till din registrerade e-postadress.",
	"helpPage_carSharing_issue2_title": "Vad händer om jag glömt mitt lösenord?",
	"helpPage_carSharing_issue3_answer": "Om du har tappat din bricka eller har fått en ny, kontakta vårt callcenter på {contactPhone} för att återställa din bricka. En ny bricka fungerar inte om den inte återställs först.",
	"helpPage_carSharing_issue3_title": "Vad gör jag om jag tappat bort min bricka eller har fått en ny?",
	"helpPage_carSharing_issue4_answer": "Registreringsnumret på din bil anges i e-postbekräftelsen och i bekräftelsen via SMS. Annars hittar du fordonet på bokningssidan Mina bokningar.",
	"helpPage_carSharing_issue4_title": "Vilket fordon bokade jag?",
	"helpPage_carSharing_issue5_answer": "Se till att datumet och tiden stämmer, startknappen är bara tillgänglig under bokningstiden. Annars kan du dra din bricka på kortläsaren för att öppna fordonets dörrar.",
	"helpPage_carSharing_issue5_title": "Varför kan jag inte hitta startknappen?",
	"helpPage_carSharing_issue6_answer": "Om du gjort en reservation och ljuset blir grönt men dörren inte öppnas, tryck då på knappen på dörrhandtaget.",
	"helpPage_carSharing_issue6_title": "Varför lyser det gröna ljuset samtidigt som dörrarna fortfarande är låsta?",
	"helpPage_carSharing_issue7_answer": "När du har bokat fordonet kan du också redigera eller avboka reservationen från webbplatsen eller mobilappen. Om du behöver hjälp kontaktar du vårt callcenter på {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Redigera / avbokning",
	"helpPage_carSharing_issue8_answer": "Du kan inte använda brickan i förväg, du kan bara öppna fordonet vid korrekt tid.",
	"helpPage_carSharing_issue8_title": "Kan jag dra brickan i förväg?",
	"helpPage_damages_issue1_answer": "Innan du påbörjar din bokade tid, se till att meddela oss om skador via din mobilapp eller genom att ringa vårt callcenter på {contactPhone}.",
	"helpPage_damages_issue1_title": "Vad gör jag om ett reserverat fordon är skadat?",
	"helpPage_damages_issue2_answer": "Håll dig lugn och se till att ingen är skadad. Du täcks av en försäkring. Kontakta vårt callcenter så snart som möjligt på {contactPhone} för vidare instruktioner.",
	"helpPage_damages_issue2_title": "Vad gör jag om det sker en olycka under min reservation?",
	"helpPage_subtitle": "Här hittar du svaren på de vanligaste frågorna.",
	"helpPage_tab_carSharing": "Service",
	"helpPage_tab_damages": "Skador",
	"helpPage_tab_vehicles": "Fordon",
	"helpPage_title": "Vanliga frågor (FAQ)",
	"helpPage_vehicles_issue1_answer": "Kontrollera datum och tidpunkt för reservationen och kontrollera sedan att registreringsnumret stämmer med bokningen. Dra sedan på nytt och se till att ENDAST din bricka dras framlös läsaren. Se till att använda den bricka som tillhör personen som utförde bokningen och att den inte bytts ut efter förra bokningen. Kontakta kundtjänst om brickan nyligen bytts ut så kan de åtgärda problemet.",
	"helpPage_vehicles_issue1_title": "Varför reagerar inte fordonet?",
	"helpPage_vehicles_issue2_answer": "Kontrollera datum och tidpunkt för reservationen och kontrollera sedan att registreringsnumret stämmer med bokningen. Se till att du har rätt bricka (den bricka som tillhör personen som utförde reservationen).",
	"helpPage_vehicles_issue2_title": "Varför visar kortläsaren bara rött ljus?",
	"helpPage_vehicles_issue3_answer": "Om du har en bokning och ljuset lyser grönt men inte hör att dörrarna blir upplåsta, tryck då på knappen på förardörren för att låsa upp dörrarna.",
	"helpPage_vehicles_issue3_title": "Varför fortsätter dörrarna vara låsta?",
	"helpPage_vehicles_issue4_answer": "Kontrollera fordonets nummerplåt, dina datum och tider samt se till att du har en fungerande internetanslutning.",
	"helpPage_vehicles_issue4_title": "Varför kan jag inte öppna dörrarna?",
	"helpPage_vehicles_issue5_answer": "Se bara till att motorn är avstängd, att dörrarna och bakluckan är ordentligt stängda och att du lagt nycklarna med det lilla chippet i lådan i handskfacket.",
	"helpPage_vehicles_issue5_title": "Varför kan jag inte låsa fordonet?",
	"home.header_banner": "I oktober blir <strong> Renault Mobility </strong> <strong> Mobilize-aktie </strong>",
	"home.welcome": "Välkommen till {productName}",
	"home.welcome_solo": "Välkommen",
	"how_it_works.step_1": "<span class='bold'>Ladda ner appen</span> från App Store eller Google Play.",
	"how_it_works.step_2": "Starta appen och <span class='bold'>registrera dig</span> genom att fylla i formuläret.",
	"how_it_works.step_3": "Ta en bild av ditt <span class='bold'>körkort</span>, ditt <span class='bold'>id-kort</span> och <span class='bold'>ta en bild av dig själv</span> med ditt id-kort intill ditt ansikte och spara allt i appen!",
	"how_it_works.step_4": "<span class='bold'>Registrera ditt bankkort</span> för att hantera betalningen av dina bokningar.",
	"how_it_works.step_5": "<span class='bold'>Bekräfta din e-postadress</span> genom att klicka på länken som du har fått. <span class='bold'>Kolla din skräppost</span>.",
	"how_it_works.step_6": "När din registrering är bekräftad kan du <span class='bold'>reservera ditt fordon</span> i vår app eller på vår webbsida. På den reserverade dagen är <span class='bold'>din smartphone din nyckel!</span>",
	"info.account.company.already.linked": "Detta företag har redan länkat till ditt konto",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Byt profil",
	"info.worldpay.return.success": "Betalningsinformation bifogad",
	"iso__BE": "Belgien",
	"iso__CS": "Tjeckien",
	"iso__DA": "Danmark",
	"iso__DE": "Tyskland",
	"iso__ES": "Spanien",
	"iso__FR": "Frankrike",
	"iso__IT": "Italien",
	"iso__NL": "Nederländerna",
	"iso__PL": "Polen",
	"iso__PT": "Portugal",
	"iso__SL": "Slovenien",
	"iso__SV": "Sverige",
	"iso__pt_BR": "Brasilien",
	"label.accept_terms_and_conditions": "Jag samtycker till att bli kontaktad av Renault och dess nätverk via e-post i undersökningssyfte eller för att få information om nya produkter eller aktuella erbjudanden. Vid varje utskick kommer jag att ha möjlighet att avsluta all kommunikation.",
	"label.account.already.active": "Ditt konto är redan aktivt",
	"label.account_activation_description": "Du kommer att få en bekräftelse via e-post när ditt konto har validerats och du kommer därefter att kunna använda tjänsten i sin helhet.",
	"label.account_activation_title": "Ditt konto kommer att valideras inom max. 15 minuter.",
	"label.activation.link.expired": "Aktiveringslänk har gått ut",
	"label.activation.link.send": "Skicka igen",
	"label.activation.link.sent.success": "Aktiveringsmejlet skickas om användaren finns och kontot inte är aktiverat",
	"label.active.profile": "Aktiv profil",
	"label.actual.payment.method": "Din nuvarande betalningsmetod",
	"label.add.new.profile": "Lägg till ny profil",
	"label.apply": "Tillämpa",
	"label.are_you_sure_you_want_to_cancel": "Vill du bekräfta avbokningen?",
	"label.birth.day": "Födelsedatum",
	"label.booking": "Bokning",
	"label.booking.past": "Förfluten",
	"label.booking.past.placeholder": "Här hittar du din bokningshistorik.",
	"label.booking.today.part": "idag",
	"label.booking.upcoming.placeholder": "Här hittar du dina inplanerade och pågående bokningar",
	"label.cancel_my_booking": "Ångra min reservation",
	"label.car": "fordon",
	"label.carSharing": "Samåkning",
	"label.cars": "fordon",
	"label.civility": "Civilstånd",
	"label.click_here": "Klicka här",
	"label.close": "Stäng",
	"label.confirm_new_password": "Bekräfta lösenord",
	"label.congratulations": "Grattis!",
	"label.continue": "Fortsätt",
	"label.creditCard_message": "I syfte att validera ditt kort kommer en tillfällig debitering att göras. En debitering på ett litet belopp om {amountToTake} € kan komma att synas på kontot som är kopplat till ditt kort. Om beloppet kvarstår i mer än fem arbetsdagar bör du kontakta din bank.",
	"label.date": "Datum",
	"label.delivery_place": "Utfärda stad",
	"label.driving_licence": "Körkort",
	"label.driving_licence_back": "Körkort (baksida)",
	"label.driving_licence_front": "Körkort (framsida)",
	"label.edit.invite.code": "Redigera inbjudningskoden",
	"label.expiration_date": "Utgångsdatum",
	"label.file.upload.only.mobile": "Använd mobilappen för att redigera dokument.",
	"label.filter_by": "Filtrera efter",
	"label.filters": "Filter",
	"label.generic.error": "Ett fel uppstod. Försök igen senare.",
	"label.hours": "timmar",
	"label.how_it_works": "Hur fungerar det?",
	"label.identity.card": "Id-kort",
	"label.identity.document.number": "Identitetshandlingens nummer",
	"label.identity.document.type": "Typ av identitetshandling",
	"label.identity_card": "Identitetshandling",
	"label.identity_card_back": "Identitetshandling (baksida)",
	"label.identity_card_front": "Identitetshandling (framsida)",
	"label.identity_card_selfie": "Selfie med identitetshandling",
	"label.invite_code_placeholder": "Ange din inbjudningskod",
	"label.italy.fiscal.code": "Ange skattemässigt nummer",
	"label.italy.resident": "Är du italienare?",
	"label.licence_number": "Körkortsnummer",
	"label.load_more": "Fler resultat",
	"label.login": "Logga in",
	"label.logout": "Logga ut",
	"label.manager.email": "E-post till din chef",
	"label.mandatory_fields": "* Obligatoriska fält",
	"label.member_already": "Redan medlem?",
	"label.my_account": "Mitt konto",
	"label.my_reservations": "Mina bokningar",
	"label.new.password": "Nytt lösenord",
	"label.no_account": "Ny medlem?",
	"label.or_by_phone": "Eller via telefon",
	"label.password": "Lösenord",
	"label.password_forgot": "Glömt lösenord",
	"label.phone": "Telefon",
	"label.phone.suffix": "Prefix",
	"label.plateNumber": "Registreringsnummer",
	"label.price": "pris",
	"label.redirectMobileApp": "Ladda ner vår mobilapp för att påbörja din bokning!",
	"label.remember_me": "Fortsätt vara inloggad",
	"label.reset_password_done": "Lösenordet har uppdaterats",
	"label.return": "Tillbaka",
	"label.schedule": "Timmar",
	"label.search": "Sök",
	"label.selected.language": "Vald språk",
	"label.subject": "Ämne",
	"label.switch.profile": "Byt profil",
	"label.the": "till",
	"label.validate": "Validera",
	"label.vehicles_found": "{count} resultat hittades",
	"label.warning": "Obs!",
	"label.welcome.finish.registration": "För att bekräfta ditt möte måste du avsluta din registrering.",
	"label.you_are_trying_to_cancel_your_booking": "Du håller på att ångra din reservation!",
	"label.your.active.profile": "Din aktiva profil",
	"label.your.other.profiles": "Dina andra profiler",
	"label.your_message": "Ditt meddelande",
	"language.header": "Välj språk",
	"login.forgot_password": "Glömt lösenordet?",
	"login.register": "Registrera",
	"menu.faq": "Info",
	"mobile_banner.text": "Ladda ner {productName} -applikationen",
	"page.password.update.sub.title": "Av säkerhetsskäl ber vi dig att uppdatera ditt lösenord",
	"page.password.update.title": "Lösenordsuppdatering",
	"parking.special_opening_legend": "Särskilda öppettider",
	"part.company.fill.extra.info": "ber dig att fylla i ytterligare information.",
	"part.complete.register.for": "Slutför din registrering för",
	"part.create.account.for": "Skapa ett konto för",
	"part.link.account.to": "Länka ditt konto till",
	"part.your.email": "din email",
	"placeholder.enter.number": "Ange ett nummer ...",
	"placeholder.enter.text": "Skriv här ...",
	"placeholder.search": "Sök ...",
	"profile.422.error.info": "Det verkar som om information saknas i din profil.\n Låt oss verifiera din profil tillsammans för att se till att allt är OK.",
	"profile.info.new.email": "Om du uppdaterar din e-postadress kommer du att få ett mejl för att verifiera e-postadressen. Om du inte verifierar den kommer du inte längre att kunna göra en bokning.",
	"profile.label.before.arrival": "Före ankomsten",
	"profile.label.before.departure": "Före avresan",
	"profile.label.charges.call.center": "För ändringar utförda av mig",
	"profile.label.charges.my": "För ändringar utförda av mig",
	"profile.label.current.password": "Nuvarande lösenord",
	"profile.label.expiration.date.status": "Mitt körkort har inget utgångsdatum",
	"profile.label.min.15": "15 minuter",
	"profile.label.min.30": "30 minuter",
	"profile.label.min.45": "45 minuter",
	"profile.label.new.email": "Ny e-postadress",
	"profile.label.street.field": "Adress (gatunummer + gatunamn)",
	"profile.label.validated.email": "Din bekräftade e-postadress",
	"profile.section.additional.info": "Övrig information",
	"profile.section.credentials": "Identitetshandlingar",
	"profile.section.language": "Profilspråk",
	"profile.section.notifications": "Meddelanden och varningar",
	"profile.section.payment.info": "Betalningsinformation",
	"profile.section.personal.info": "Personuppgifter",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Tillgång till tekniker",
	"profile.select.menu.item": "Välj ett alternativ i menyn till vänster",
	"profile.selfie.section.info": "Ta en selfie som visar ditt id-kort intill ditt ansikte.",
	"profile.suspended": "Din profil är avstängd",
	"profile.title.email.notifications": "Meddelanden via e-post",
	"profile.title.language.select": "Språk som används för aviseringar och e-postmeddelanden",
	"profile.title.sms.notifications": "Sms-aviseringar",
	"profile.title.update.email": "Uppdatera din e-postadress",
	"profile.title.update.password": "Uppdatera ditt lösenord",
	"profile_error_driver_license_invalid": "Körkortet är inte giltigt",
	"register.field.info.password": "Måste innehålla minst 1 siffra, 1 stor bokstav, 1 liten bokstav och mellan 8 och 25 tecken",
	"register.info.payment.saved": "Betalningsmetod har sparats.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "En aktiveringslänk har skickats till {email}. Kolla din e-post och skräppost, och följ sedan instruktionerna för att aktivera ditt konto innan länken går ut.",
	"register.terms.ads": "Jag samtycker till att mina uppgifter behandlas för marknadsföringsändamål (med både automatiserade och traditionella metoder) i samband med mobilitetsprodukter och/eller tjänster.",
	"register.terms.prefix.accept": "Jag godkänner",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "integritetspolicyn",
	"register.terms.root.tos": "abonnemangsvillkoren",
	"register.terms.root.tou": "användarvillkoren",
	"register.terms.suffix.ads": "användning av mina uppgifter i kommersiellt syfte",
	"register.terms.suffix.of": "av",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Gratulerar {firstName}, ditt konto har skapats",
	"register.title.account.linked": "Grattis {firstName}, ny profil har länkats till ditt konto",
	"register.title.account.updated": "Grattis {firstName}, ditt konto har uppdaterats",
	"reset_password.title": "Återställ lösenord",
	"search.filter_alphabetically": "Alfabetisk ordning",
	"search.filter_by": "Sortera efter",
	"search.filter_by_price": "Pris",
	"search.result.empty": "Inget sökresultat",
	"service.corporate.intro": "Vill du också vara med i vår community? Ange din inbjudningskod.",
	"service.intro_label": "Vilken {productName}-tjänst vill du abonnera på?",
	"service.private.intro": "Vill du boka ett fordon från {productName} nätverk?",
	"service.private.renaultfr": "För att abonnera på {productName} behöver du ladda ner appen till din mobil.",
	"service.private.select_country": "Välj ett land",
	"service.usage.corporate": "Bildelning för företag",
	"service.usage.private": "Biluthyrning dygnet runt",
	"service.usage.vr": "Ersättningsfordon",
	"service.vr.intro": "Tack för ditt intresse för vår tjänst!\n\nFör att bli medlem behöver du kontakta din återförsäljare för att få en registreringslänk.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Ange din arbetsmailadress",
	"sso.login.title": "Anslut till SSO",
	"status.APPROVED": "Profilen validerad",
	"status.NOT_APPROVED": "Din profil avvisas. Uppdatera din profil.",
	"status.TO_COMPLETE": "Ofullständig",
	"status.TO_REVIEW": "Din profil väntar på validering",
	"tagline": "Biluthyrning med självbetjäning – dygnet runt",
	"title.add.payment.later": "Du kan lägga till det senare.",
	"title.add.payment.method": "Lägg till en betalningsmetod.",
	"title.bookings.welcome.tutorial": "Hitta din bokning här, den är redan planerad",
	"title.modify.booking": "Ändra min bokning",
	"title.password.change.success": "Ditt nya lösenord har sparats",
	"title.update.booking": "Uppdatera bokning",
	"title.welcome.to.brand": "Hej {firstName}, välkommen till {brandName}.",
	"title.welcome.to.program": "Hej {firstName}, välkommen till {brandName} {program}.",
	"vehicle.incorrect.usage": "Fordonet är inte tillgängligt för denna typ av användning",
	"week.day.friday": "Fredag",
	"week.day.monday": "Måndag",
	"week.day.saturday": "Lördag",
	"week.day.sunday": "Söndag",
	"week.day.thursday": "Torsdag",
	"week.day.tuesday": "Tisdag",
	"week.day.wednesday": "Onsdag"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/sv.json
 ** module id = 430
 ** module chunks = 0
 **/